module.exports = __webpack_public_path__ + "static/media/Makershuis Logo.1500db9e.png";